import { PlansApi } from 'src/orchd-client';

import { axiosInstance } from 'src/utils/axios';

export const plansApi = PlansApi({}, '/api', axiosInstance);
